import React from 'react';

function About() {
  return (
    <main>
      {/* Page Header */}
      <section className="py-5 bg-light">
        <div className="container">
          <h1 className="text-center">About Us</h1>
        </div>
      </section>

      {/* History Section */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h2 className="section-title">Our History</h2>
              <p>The DSR Dist. Headquarters Hospital, Nellore was built in 1963 to 1968. Foundation Stone laid by the Honourable Chief Minister of Andhra Pradesh Sri Neelam Sanjeeva Reddy. Inaugurated on 18/12/1968 by the Chief Minister of Karnataka Sri.Veerendra Patil and preceded by the Honourable Chief Minister of Andhra Pradesh, Sri. Kasu Brahmanada Reddy.</p>
              <p>In 2013 this District head Quarters Hospital upgraded and converted into Medical College & Teaching Hospital by Hon'ble Chief Minister of Andhra Pradesh Sri. Nallari Kiran Kumar Reddy.</p>
              
              <h3 className="mt-5 mb-4">Timeline</h3>
              <div className="timeline">
                <div className="timeline-item">
                  <div className="timeline-date">1963-1968</div>
                  <div className="timeline-content">
                    <h4>Construction Period</h4>
                    <p>The DSR District Headquarters Hospital was built during this period.</p>
                  </div>
                </div>
                
                <div className="timeline-item">
                  <div className="timeline-date">December 18, 1968</div>
                  <div className="timeline-content">
                    <h4>Inauguration</h4>
                    <p>Inaugurated by the Chief Minister of Karnataka Sri.Veerendra Patil and preceded by the Honourable Chief Minister of Andhra Pradesh, Sri. Kasu Brahmanada Reddy.</p>
                  </div>
                </div>
                
                <div className="timeline-item">
                  <div className="timeline-date">2013</div>
                  <div className="timeline-content">
                    <h4>Upgraded to Medical College</h4>
                    <p>The District Headquarters Hospital was upgraded and converted into Medical College & Teaching Hospital by Hon'ble Chief Minister of Andhra Pradesh Sri. Nallari Kiran Kumar Reddy.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision and Mission Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h2 className="section-title">Vision and Mission</h2>
              
              <div className="card mb-4 border-0 shadow-sm">
                <div className="card-body">
                  <h3 className="card-title">Vision</h3>
                  <p className="card-text">The future is embodied in the present generation. Professional education combined with practical exposure to create values in the students and employees who are the future of our nation.</p>
                </div>
              </div>
              
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h3 className="card-title">Mission</h3>
                  <p className="card-text">Work oriented education and employment support with ethical values, character building in context of today's millennium.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
